import { toast } from 'sonner';

// NO "CHECK YOUR CONNECTION": AN OFFLINE WRITE NEVER REJECTS (IT SETTLES ON RECONNECT), SO THIS
// ONLY EVER SHOWS FOR A SERVER REFUSAL — WHICH A CONNECTION CHECK CANNOT FIX.
export const CHART_SAVE_ERROR_MESSAGE =
  "We couldn't save your changes. Please try again, and if this keeps happening, contact support.";

// A STABLE id MAKES SONNER UPDATE ONE TOAST IN PLACE RATHER THAN STACK NEW ONES. ⚠️ THIS HIDES
// REPEATS; IT DOES NOT STOP THEM. A PLAIN useEffect([chart]) INIT WRITE THAT IS REJECTED LOOPS ON
// EVERY ROUND TRIP (FIRESTORE APPLIES THE WRITE LOCALLY, THEN ROLLS IT BACK). BACKGROUND WRITES
// MUST GO THROUGH useInitChartSection, WHICH ISSUES THEM ONCE PER FAILURE (CU-17tm466jq2e).
export const CHART_SAVE_ERROR_TOAST_ID = 'chart-save-error';

/**
 * Tells the patient a chart save failed. Reporting is not done here: `useUpdateChartSection`
 * already sends the error to Sentry before rethrowing it.
 */
export function notifyChartSaveError(): void {
  toast.error(CHART_SAVE_ERROR_MESSAGE, { id: CHART_SAVE_ERROR_TOAST_ID, duration: 8000 });
}
